import { render, staticRenderFns } from "./TemplateMailViewGlobal.vue?vue&type=template&id=dbbbce4a&scoped=true&"
import script from "./TemplateMailViewGlobal.vue?vue&type=script&lang=js&"
export * from "./TemplateMailViewGlobal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMailViewGlobal.vue?vue&type=style&index=0&id=dbbbce4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbbce4a",
  null
  
)

export default component.exports